import React from "react";

// components
import { Card, CardBody, CardFooter, CardTitle, Row, Col, Spinner, Label } from "reactstrap";
import parse from 'html-react-parser';

// style
import "assets/css/loading.css";

// helpers
import { transformFloatToString, transformValueFloattoFormated } from "helpers/formats.js";

// logos
import logo_spRegula from "assets/img/SPRegula.png";
import logo_saopaulo from "assets/img/saopaulo.png";

import Acoes from "./Acoes";

import MapaLeaflet from "components/Map/Mapa-Leaflet";
import MapaCalorLeaflet from "components/Map/MapaCalor-Leaflet";
import MapaPolyInfoLeaflet from "components/Map/MapaPolyInfoLeaflet";

import { Bar } from 'react-chartjs-2';
import GaugeChart from 'react-gauge-chart';

export default function PainelMapa(props) {
  const {
    showLoading,
    painel,
    centerMap,
    zoomMap,
    showPlay,
    toggleModalSetup,
    handleConfirmaSetup,
    handleBackward,
    handlePauseMap,
    handlePlayMap,
    handleForward
  } = props;

  const handleCard = (item) => {
    return (
      <Row>
        <Col md="4" xs="3">
          <div className={"icon-big text-center " + item.color}>
            <i className={item.icon}></i>
          </div>
        </Col>
        <Col md="8" xs="9">
          <div className="numbers">
            <p className="card-category">{item.titulo}</p>
            <CardTitle tag="p">
              {!showLoading && item.mascara == "milhar" &&
                <Label style={{ color: "#2c2c2c" }}>{transformFloatToString(item.total)}</Label>
              }
              {!showLoading && item.mascara == "percentual" &&
                <Label style={{ color: "#2c2c2c" }}>{transformValueFloattoFormated(item.total)}%</Label>
              }
              {!showLoading && item.mascara != "milhar" && item.mascara != "percentual" &&
                <Label style={{ color: "#2c2c2c" }}>{transformValueFloattoFormated(item.total)}</Label>
              }
              {showLoading &&
                <Spinner />
              }
            </CardTitle>
            <p />
          </div>
        </Col>
      </Row>
    );
  }

  const handleCardSm = (item) => {
    return (
      <Row>
        <Col md="8" xs="8">
          <strong>{item.titulo}</strong>
        </Col>
        <Col md="4" xs="4">
          <strong>{item.descricao}</strong>
        </Col>
      </Row>
    );
  }

  const handleCardHtml = (item) => {
    return (
      <Row>
        <Col md="12" xs="12">
          <strong>{item.titulo}</strong>
        </Col>
        <Col md="12" xs="12" className="mt-2">
          {parse(item.descricao)}
        </Col>
      </Row>
    );
  }

  const handleGrafico = (item) => {
    return (
      <Row>
        {item.grafico.type == "gauge" && item.grafico.gaugeCharts.map((chart, key) => (
          <Col key={key} md="12" xs="12">
            <GaugeChart id="gauge-chart2"
              animate={false}
              nrOfLevels={chart.numeroLevel}
              colors={['#EA4228', '#F5CD19', '#5BE12C']}
              percent={chart.valor}
              textColor={"#282c34"}
            />
          </Col>
        ))}
        {item.grafico.type != "gauge" &&
          <Col md="12" xs="12">
            <Bar data={item.grafico} />
          </Col>
        }
      </Row>)
  }

  return (
    <>
      <Card className="card-stats">
        {(painel != null) && painel.grupo &&
          <CardBody>
            <Row>
              <Col md="3" xs="12">
                <Acoes
                  showLoading={showLoading}
                  showPlay={showPlay}
                  handleBackward={handleBackward}
                  handlePauseMap={handlePauseMap}
                  handlePlayMap={handlePlayMap}
                  handleForward={handleForward}
                  toggleModalSetup={toggleModalSetup}
                  handleConfirmaSetup={handleConfirmaSetup}
                />
                <Row>
                  <Col md="12" xs="12">
                    {painel.titulo &&
                      <h4 className="title" style={{ marginBottom: "0" }}>
                        {painel.titulo}
                      </h4>
                    }
                  </Col>
                </Row>
                {painel.subTitulo != null && painel.subTitulo != "" &&
                  <Row>
                    <Col md="12" xs="12">
                      <h5 style={{ marginBottom: "0" }}>
                        {painel.subTitulo}
                      </h5>
                    </Col>
                  </Row>
                }
                {painel.descricao != null && painel.descricao != "" &&
                  <Row>
                    <Col md="12" xs="12">
                      <small>{painel.descricao}</small>
                    </Col>
                  </Row>
                }
                {(painel != null) && (painel.cards != null) && painel.cards.map((item, key) => (
                  <Card key={key} className="card-stats">
                    <CardBody>
                      {item.tipoCard == "Card" && handleCard(item)}
                      {item.tipoCard == "Card sm" && handleCardSm(item)}
                      {item.tipoCard == "Gráfico" && handleGrafico(item)}
                      {item.tipoCard == "Card html" && handleCardHtml(item)}
                    </CardBody>
                    {item.tipoCard == "Card" && item.descricao &&
                      <CardFooter>
                        <hr />
                        <div className="stats">
                          {item.descricao}
                        </div>
                      </CardFooter>
                    }
                  </Card>
                ))}
              </Col>
              <Col md="9" xs="12">
                {(painel != null) && (painel.mapa != null) && painel.mapa.type == "Markers" &&
                  <MapaLeaflet
                    showLoading={showLoading}
                    centerMap={centerMap}
                    zoomMap={zoomMap}
                    markers={painel.mapa.markers}
                    polygon={painel.mapa.polygon}
                    markerCluster={painel.mapa.markerCluster}
                  />
                }
                {(painel != null) && (painel.mapa != null) && painel.mapa.type == "Heatmap" &&
                  <MapaCalorLeaflet
                    showLoading={showLoading}
                    centerMap={centerMap}
                    zoomMap={zoomMap}
                    markers={painel.mapa.markers}
                  />
                }
                {painel != null && painel.mapa != null && painel.mapa.type == "PolyInfo" &&
                  <MapaPolyInfoLeaflet
                    showLoading={showLoading}
                    centerMap={centerMap}
                    zoomMap={zoomMap}
                    polygons={painel.mapa.polygonsInfo}
                  />
                }
                <Row className="mt-1">
                  <Col md="4" xs="4" className="text-left">
                    <img src={logo_spRegula} height={"50px"} />
                  </Col>
                  <Col md="4" xs="4" className="text-right">
                    <img src={logo_saopaulo} height={"50px"} style={{ marginBottom: "10px" }} />
                  </Col>
                </Row>
              </Col>
            </Row>
          </CardBody>
        }
      </Card>
    </>
  );
}